import BuyButton from './buy'
import LoginButton from './login'
import ShareButton from './share'
import VIPDetailButton from './vipDetail'
import DownloadButton from './download'
import NavigateButton from './navigate'
import DiscontinuedButton from './discontinued'



export {
  BuyButton,LoginButton,ShareButton,VIPDetailButton,DownloadButton,NavigateButton,DiscontinuedButton
}
